import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { defaultConfig } from "./default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";

export const DemandNoPerspectiveContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "sales_order_master",
        transformId: "sales_order_master_date_pivot",
        folder: "outputs",
        title: "Demand",
        dateHierarchyColumnFilter: {
          order_placed_month: "month",
          order_placed_week: "week",
          order_placed_year: "year",
          order_placed_quarter: "quarter",
          order_placed_date: "day",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {
          quantity: "quantity",
          revenue: "revenue",
          cost: "cost",
        },
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.DatePeriodPicker,
          PivotControl.FilterBy,
          PivotControl.Measure,
          PivotControl.SegmentSelectMulti,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
          PivotControl.ShowSettings,
          PivotControl.EnableChartView,
        ],
        shadeHistory: true,
        showHeaderRow: true,
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
